<p-dialog
    [(visible)]="displayDialog"
    [style]="{ width: '30vw' }"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [closable]="true"
    (onHide)="onDialogClosed()"
    [header]="cuestionario ? 'Editar Cuestionario' : 'Nuevo Cuestionario'"
>
    <form [formGroup]="form" (ngSubmit)="onSubmit()" appPermissionControl="P237F0001">
        <div class="form-row mt-3">
            <div class="form-field">
                <input pInputText type="text" formControlName="sClaveCues" class="form-control"
                    [placeholder]="'Ingrese Clave Cuestionario'" appPermissionControl="P237K0001">
                <label>Clave Cuestionario</label>
            </div>
        </div>

        <div class="form-row">
            <div class="form-field">
                <input pInputText type="text" formControlName="sDescripcion" class="form-control"
                    [placeholder]="'Ingrese Descripción'" appPermissionControl="P237K0002">
                <label>Descripción</label>
            </div>
        </div>

        <div class="form-row">
            <div class="form-field">
                <p-dropdown [options]="tipos" formControlName="iTipo" optionLabel="label" optionValue="value" appendTo="body"
                    placeholder="Seleccione un tipo" class="w-100" appPermissionControl="P237K0003"></p-dropdown>
                <label>Tipo</label>
            </div>
        </div>

        <div class="form-row">
            <div class="form-field">
                <p-dropdown [options]="gestiones" formControlName="iGestion" optionLabel="label" optionValue="value" appendTo="body"
                    placeholder="Seleccione una gestión" class="w-100" appPermissionControl="P237K0004"></p-dropdown>
                <label>Gestión</label>
            </div>
        </div>

        <div class="field-checkbox">
            <label class="checkbox-container">
                <input type="checkbox" formControlName="bTodos" appPermissionControl="P237K0005">
                <span class="checkmark"></span>
                Todos
            </label>
        </div>

        <div class="button-section">
            <button mat-flat-button class="btn-success btn-menu" type="submit" [disabled]="!form.valid || loading" appPermissionControl="P237B0001">
                <mat-icon *ngIf="!loading">save</mat-icon>
                <p-progressSpinner *ngIf="loading" styleClass="w-4rem h-4rem" strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
                {{ cuestionario ? 'Actualizar' : 'Guardar' }}
            </button>
            <button *ngIf="cuestionario" mat-flat-button class="btn-search btn-menu" type="button" (click)="openCustomizables()" appPermissionControl="P237B0002">
                <mat-icon>tune</mat-icon>
                Customizables
            </button>
        </div>
        <div class="button-section mt-2">
            <button mat-flat-button class="btn-new btn-menu" type="button" *ngIf="cuestionario" (click)="openPreguntas()" appPermissionControl="P237B0003">
                <mat-icon>question_answer</mat-icon>
                Preguntas
            </button>
            <button mat-flat-button class="btn-edit btn-menu" type="button" (click)="openTipos()" *ngIf="cuestionario" appPermissionControl="P237B0004">
                <mat-icon>list</mat-icon>
                Tipos
            </button>
        </div>
    </form>
</p-dialog>

<app-tipos-dialog
    [(displayDialog)]="displayTiposDialog"
    [cuestionario]="selectedCuestionario"
    (onHide)="onTiposDialogClosed($event)"
></app-tipos-dialog>

<app-preguntas-dialog
    [(displayDialog)]="displayPreguntasDialog"
    [cuestionario]="selectedCuestionario"
    (onHide)="onPreguntasDialogClosed($event)"
></app-preguntas-dialog>

<p-toast position="bottom-right"></p-toast>

<style>
    :host ::ng-deep .field-checkbox {
        display: flex;
        align-items: center;
        margin-bottom: 1rem;
    }

    :host ::ng-deep .checkbox-container {
        display: flex;
        align-items: center;
        position: relative;
        padding-left: 35px;
        cursor: pointer;
        font-size: 0.9rem;
        color: #495057;
        user-select: none;
    }

    :host ::ng-deep .checkbox-container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    :host ::ng-deep .checkmark {
        position: absolute;
        left: 0;
        height: 20px;
        width: 20px;
        background-color: #fff;
        border: 1px solid #ced4da;
        border-radius: 4px;
    }

    :host ::ng-deep .checkbox-container:hover input ~ .checkmark {
        border-color: #2196F3;
    }

    :host ::ng-deep .checkbox-container input:checked ~ .checkmark {
        background-color: #2196F3;
        border-color: #2196F3;
    }

    :host ::ng-deep .checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    :host ::ng-deep .checkbox-container input:checked ~ .checkmark:after {
        display: block;
    }

    :host ::ng-deep .checkbox-container .checkmark:after {
        left: 7px;
        top: 3px;
        width: 5px;
        height: 10px;
        border: solid white;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
    }
</style>